import noSelectedText from "Common/componentUtils/noSelectedText";
import Button from "Components/button";
import Sortable from "devextreme-react/sortable";
import includes from "lodash/includes";
import map from "lodash/map";
import reject from "lodash/reject";
import React, { memo, useCallback, useState } from "react";
import NodeAttributeCreatorPanel from "../../../nodeAttributeCreatorPanel";
import NodeAttributeEditor from "../../../nodeAttributeEditor";
import locale from "./nodeAttributes.locale";
const sortHandlerClassName = "node-attribute-sort-handler";
function NodeAttributes(props) {
    const [openedBlocks, setOpenedBlocks] = useState([]);
    const [creatorOpened, setCreatorOpened] = useState(false);
    const handleCreatorClose = useCallback(() => {
        setCreatorOpened(false);
    }, []);
    const handleCreatorOpen = useCallback(() => {
        setCreatorOpened(true);
    }, []);
    const handleOpenedToggle = useCallback((attributeId) => {
        noSelectedText() &&
            setOpenedBlocks(prev => includes(prev, attributeId) ? reject(prev, e => e === attributeId) : [...prev, attributeId]);
    }, []);
    const handleDataUpdate = useCallback((attributeId, fieldName, value) => {
        props.onDataUpdate &&
            props.onDataUpdate(props.documentObjectId, attributeId, fieldName, value);
    }, [props.documentObjectId, props.onDataUpdate]);
    const handleAttributeDelete = useCallback((attributeId) => {
        props.onDelete && props.onDelete(props.documentObjectId, attributeId);
    }, [props.documentObjectId, props.onDelete]);
    const handleAttributeAdd = useCallback((attribute) => {
        props.onAdd && props.onAdd(props.documentObjectId, attribute);
    }, [props.documentObjectId, props.onDelete]);
    const handleDragEnd = useCallback((e) => {
        if (!props.onSort || !props.attributes || e.fromIndex === e.toIndex)
            return;
        const result = [...props.attributes];
        const attributeFrom = result[e.fromIndex];
        result.splice(e.fromIndex, 1);
        result.splice(e.toIndex, 0, attributeFrom);
        props.onSort(props.documentObjectId, result);
    }, [props.documentObjectId, props.onSort, props.attributes]);
    const editors = map(props.attributes, (item, index) => (React.createElement(NodeAttributeEditor, { dotsBlockClassName: props.onSort ? sortHandlerClassName : undefined, key: `${item.Id}_${index}`, data: item, opened: includes(openedBlocks, item.Id), onOpenedToggle: handleOpenedToggle, onDataUpdate: props.onDataUpdate ? handleDataUpdate : undefined, onDelete: props.onDelete ? handleAttributeDelete : undefined, zIndex: props.zIndex })));
    return (React.createElement("div", { className: props.className },
        props.onAdd && (React.createElement("div", { className: "pt-0_75 pb-0_75 pl-xs pr-xs border-bottom-gray-100" },
            React.createElement(Button, { onClick: handleCreatorOpen, className: "w-100" },
                React.createElement("i", { className: "icon-add font-h4 mr-0_25 text-light-on-surface" }),
                locale.CREATE_ATTRIBUTE))),
        props.onSort ? (React.createElement(Sortable, { allowReordering: true, itemOrientation: "vertical", handle: `.${sortHandlerClassName}`, onDragEnd: handleDragEnd }, editors)) : (editors),
        props.onAdd && (React.createElement(NodeAttributeCreatorPanel, { open: creatorOpened, documentObjectId: props.documentObjectId, onClose: handleCreatorClose, onAdd: handleAttributeAdd, generateAttributeId: props.generateAttributeId }))));
}
export default memo(NodeAttributes);
